import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router'
import { useAuthStore } from '@/stores/authStore'

/**
 * Wraps all protected routes.
 *
 * - While auth is initialising → show a full-screen spinner.
 * - If unauthenticated → save the intended destination then redirect to
 *   the Cognito Hosted UI via signInWithRedirect().
 * - If authenticated → render children.
 */
export function AuthGuard() {
  const { isAuthenticated, isLoading, isSigningOut, signIn } = useAuthStore()
  const location = useLocation()

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !isSigningOut) {
      // Persist the path the user was trying to reach so CallbackPage can
      // send them there after the OAuth exchange completes.
      sessionStorage.setItem('redirectAfterAuth', location.pathname)
      signIn()
    }
  }, [isLoading, isAuthenticated, isSigningOut, location.pathname, signIn])

  if (isLoading || isSigningOut || !isAuthenticated) {
    return (
      <div className="flex h-screen items-center justify-center bg-birch-50">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-birch-300 border-t-birch-600" />
      </div>
    )
  }

  return <Outlet />
}
